// extracted by mini-css-extract-plugin
export default {"root":"MenuContent_root__2WHDs","isClosed":"MenuContent_isClosed__bWI18","isOpen":"MenuContent_isOpen__HjE+i","content":"MenuContent_content__YNhh6"};